import { render } from "./LedgerRow.vue?vue&type=template&id=96459992&scoped=true"
import script from "./LedgerRow.vue?vue&type=script&lang=js"
export * from "./LedgerRow.vue?vue&type=script&lang=js"

import "./LedgerRow.vue?vue&type=style&index=0&id=96459992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96459992"]])

export default __exports__